import { Route } from '@angular/router';

/** 메인 LayoutComponent 안에 등록할 행사 목록 라우트 */
export const EventListRoute: Route = {
  path: 'event',
  loadComponent: () => import('../pages/event/event-list/event-list.page'),
};

/** 최상위에 등록할 행사 서브 레이아웃 라우트 */
export const EventDetailRoute: Route = {
  path: 'event/:id',
  loadComponent: () => import('../layout/event-layout/event-layout.component'),
  children: [
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
    },
    {
      path: 'dashboard',
      loadComponent: () =>
        import('../pages/event/event-dashboard/event-dashboard.page'),
    },
    {
      path: 'application',
      loadComponent: () =>
        import('../pages/event/event-application/event-application.page'),
    },
  ],
};
